import "./insHorizontalBarDatapointChart.scss";
import React from "react";
import { useDispatch } from "react-redux";
import { InsBaseHorizontalBarChart } from "./insBaseHorizontalBarChart";
import { useGetHorizontalBarChartConfig } from "./use-get-horizontal-bar-chart-config";
import { useCurrentWidgetState } from "components/widgets/hooks/use-current-widget";
import { setCurrentStatusMasterDetails } from "store/current-dashboard";
export const InsHorizontalBarDatapointChart = (props) => {
    const widgetState = useCurrentWidgetState(props.sectionId, props.widgetId);
    const config = useGetHorizontalBarChartConfig(props);
    const masterDetailChoiceIndex = config.series.length === 0 ? -1 : config.series[0].findIndex((s) => s.custom?.id === widgetState?.masterDetailsChoice);
    const dispatch = useDispatch();
    if (config.options.series) {
        for (const item of config.options.series) {
            item.events = {
                click(event) {
                    if (config.childrenId) {
                        dispatch(setCurrentStatusMasterDetails({
                            childrenId: config.childrenId,
                            sectionId: props.sectionId,
                            selectedValue: event.point?.options?.custom?.id,
                            widgetId: props.widgetId
                        }));
                    }
                }
            };
        }
    }
    return React.createElement(InsBaseHorizontalBarChart, { ...props, ...config, masterDetailChoiceIndex: Math.max(0, masterDetailChoiceIndex), hasData: config.series.length > 0 && config.series[0]?.length > 0 });
};
